"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormSubmitButtons = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _loading_spinner = _interopRequireDefault(require("../loading_spinner"));
var _button = _interopRequireDefault(require("../button"));
var _link = _interopRequireDefault(require("../../typography/link"));
var _excluded = ["compact", "children", "extraAction"],
  _excluded2 = ["onCancel", "children"],
  _excluded3 = ["onSubmit", "children", "isSubmitting", "fancy"]; // @ts-expect-error - TS7016 - Could not find a declaration file for module '../loading_spinner'. 'src/azalea/components/loading_spinner.js' implicitly has an 'any' type.
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Row = function Row(_ref) {
  var _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    children = _ref.children,
    extraAction = _ref.extraAction,
    otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Container
  // @ts-expect-error - TS2769 - No overload matches this call.
  , (0, _extends2["default"])({
    compact: compact,
    className: "form-submit-buttons"
  }, otherProps), extraAction && /*#__PURE__*/React.createElement(ControlSet, {
    className: "extra"
  }, extraAction), /*#__PURE__*/React.createElement(ControlSet, {
    className: "standard"
  }, children));
};
var Cancel = function Cancel(_ref2) {
  var onCancel = _ref2.onCancel,
    children = _ref2.children,
    otherProps = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  function cancel(event) {
    event.preventDefault();
    if (onCancel) {
      onCancel();
    }
  }
  return /*#__PURE__*/React.createElement(CancelLink, (0, _extends2["default"])({
    href: "#",
    onClick: cancel
  }, otherProps), children);
};
var Submit = function Submit(_ref3) {
  var onSubmit = _ref3.onSubmit,
    children = _ref3.children,
    _ref3$isSubmitting = _ref3.isSubmitting,
    isSubmitting = _ref3$isSubmitting === void 0 ? false : _ref3$isSubmitting,
    _ref3$fancy = _ref3.fancy,
    fancy = _ref3$fancy === void 0 ? false : _ref3$fancy,
    otherProps = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(_button["default"], (0, _extends2["default"])({
    style: {
      marginLeft: 15
    },
    fancy: fancy
  }, otherProps), /*#__PURE__*/React.createElement(ButtonText, {
    isSubmitting: isSubmitting
  }, children), isSubmitting && /*#__PURE__*/React.createElement(SpinnerContainer, null, /*#__PURE__*/React.createElement(_loading_spinner["default"], {
    size: "small",
    flavor: fancy ? 'pale' : 'green'
  })));
};
var FormSubmitButtons = exports.FormSubmitButtons = {
  Row: Row,
  Cancel: Cancel,
  Submit: Submit
};
var SpinnerContainer = _styledComponents["default"].div.withConfig({
  displayName: "compound_components__SpinnerContainer"
})(["position:absolute;left:50%;top:calc(50% + 2px);transform:translate(-50%,-50%);"]);
var ButtonText = _styledComponents["default"].span.withConfig({
  displayName: "compound_components__ButtonText"
})(["", ""], function (props) {
  return (
    // @ts-expect-error - TS2339 - Property 'isSubmitting' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>, "key" | keyof HTMLAttributes<HTMLSpanElement>> & { ...; }, DefaultTheme>'.
    props.isSubmitting && "\n   color: transparent;\n   visibility: hidden;\n "
  );
});
var Container = _styledComponents["default"].div.withConfig({
  displayName: "compound_components__Container"
})(["font-family:Untitled Sans,sans-serif;", " margin-top:", ";display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap-reverse;width:100%;"], /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.compact ? '0' : '20px';
});
var ControlSet = _styledComponents["default"].div.withConfig({
  displayName: "compound_components__ControlSet"
})(["display:flex;flex-wrap:wrap-reverse;justify-content:flex-end;align-items:center;&:last-child{margin-left:auto;}"]);
var CancelLink = (0, _styledComponents["default"])(_link["default"]).withConfig({
  displayName: "compound_components__CancelLink"
})(["cursor:pointer;font-size:14px;"]);